import React from 'react'
import Icon from '@ant-design/icons'

const HistorySvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor">
    <path
      d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C8.35779 20.0026 6.74043 19.5989 5.29201 18.825L9.1306e-06 20L1.17601 14.71C0.401771 13.2609 -0.00221457 11.6429 9.1306e-06 10C9.1306e-06 4.477 4.47701 0 10 0ZM11 5H9.00001V12H15V10H11V5Z"
      />
  </svg>
)

const HistoryIcon = props => <Icon component={HistorySvg} {...props} />

export default HistoryIcon